module.exports = __webpack_public_path__ + "img/play-store.5904460b.svg";